<form [formGroup]="formGroup">
  <div>
    <h4>{{ 'agents.trainingForm.title' | translate }}</h4>
    <small>{{ 'agents.trainingForm.subtitle' | translate }}</small>
  </div>

  <div class="mt-3">
    <div class="alert alert-info m-1 fw-semibold fs-5 mb-3" role="alert">
      <i class="mdi mdi-information-outline"></i>
      <span class="ms-1"
        >{{ 'agents.trainingForm.infoBanner' | translate }}</span
      >
    </div>

    <ul class="nav nav-pills bg-nav-pills nav-justified font-16" role="tablist">
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [ngClass]="{ active: activeTrainingType === TrainingTypeEnum.TEXT }"
          (click)="changeTrainingType(TrainingTypeEnum.TEXT)"
          id="text-tab"
          data-bs-toggle="tab"
          data-bs-target="#text"
          type="button"
          role="tab"
          aria-controls="text"
          [attr.aria-selected]="activeTrainingType === TrainingTypeEnum.TEXT"
        >
          <i class="mdi mdi-text-box-outline"></i>
          <span class="d-none d-md-inline ms-2">{{ 'agents.trainingForm.tabText' | translate }}</span>
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [ngClass]="{
            active: activeTrainingType === TrainingTypeEnum.WEBSITE
          }"
          (click)="changeTrainingType(TrainingTypeEnum.WEBSITE)"
          id="website-tab"
          data-bs-toggle="tab"
          data-bs-target="#website"
          type="button"
          role="tab"
          aria-controls="website"
          [attr.aria-selected]="activeTrainingType === TrainingTypeEnum.WEBSITE"
        >
          <i class="mdi mdi-link-variant"></i>
          <span class="d-none d-md-inline ms-2">{{ 'agents.trainingForm.tabWebsite' | translate }}</span>
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [ngClass]="{
            active: activeTrainingType === TrainingTypeEnum.VIDEO
          }"
          (click)="changeTrainingType(TrainingTypeEnum.VIDEO)"
          id="video-tab"
          data-bs-toggle="tab"
          data-bs-target="#video"
          type="button"
          role="tab"
          aria-controls="video"
          [attr.aria-selected]="activeTrainingType === TrainingTypeEnum.VIDEO"
        >
          <i class="mdi mdi-video-outline"></i>
          <span class="d-none d-md-inline ms-2">{{ 'agents.trainingForm.tabVideo' | translate }}</span>
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [ngClass]="{
            active: activeTrainingType === TrainingTypeEnum.DOCUMENT
          }"
          (click)="changeTrainingType(TrainingTypeEnum.DOCUMENT)"
          id="files-tab"
          data-bs-toggle="tab"
          data-bs-target="#files"
          type="button"
          role="tab"
          aria-controls="files"
          [attr.aria-selected]="
            activeTrainingType === TrainingTypeEnum.DOCUMENT
          "
        >
          <i class="mdi mdi-upload-outline"></i>
          <span class="d-none d-md-inline ms-2">{{ 'agents.trainingForm.tabFiles' | translate }}</span>
        </a>
      </li>
    </ul>

    <div class="tab-content p-3 mt-2">
      <!-- Text -->
      <div
        class="tab-pane fade show active"
        id="text"
        role="tabpanel"
        aria-labelledby="text-tab"
      >
        @if(activeTrainingType === TrainingTypeEnum.TEXT) {
          <div class="row border rounded p-3">
            <div>
              <label for="trainingText" class="form-label"
                >{{ 'agents.trainingForm.textLabel' | translate }}</label
              >
              <textarea
                id="trainingText"
                #trainingText
                class="form-control"
                formControlName="text"
                [placeholder]="'agents.trainingForm.textPlaceholder' | translate"
                maxlength="1028"
                rows="5"
                (keydown.enter)="$event.preventDefault(); addTrainingText()"
                style="min-height: 120px;"
              ></textarea>
              <small class="text-muted float-end">
                {{ trainingText.value?.length || 0 }}/1028
              </small>
            </div>

            <div class="mt-3 d-flex align-items-center justify-content-end gap-2">
              @if(editingTrainingId) {
              <button
                type="button"
                class="btn btn-outline-secondary"
                (click)="cancelEditText()"
              >
                {{ 'agents.trainingForm.cancelButton' | translate }}
              </button>
              }
              <button
                type="button"
                class="btn btn-success d-flex align-items-center justify-content-center"
                [disabled]="
                  loading || !formGroup.get('text')?.value?.trim()
                "
                (click)="addTrainingText()"
              >
                {{ !loading ? (editMode() ? ('agents.trainingForm.updateButton' | translate) : ('agents.trainingForm.saveButton' | translate)) : "" }}
                @if(loading) {
                <mat-spinner
                  [diameter]="25"
                  [color]="'accent'"
                  mode="indeterminate"
                />
                }
              </button>
            </div>
          </div>

          @if(trainingList?.data?.length > 0 && !editMode()) {
            <div class="row p-1 mt-2">
              <span>
                {{ 'agents.trainingForm.registeredTrainings' | translate }}
                <strong>{{ trainingList.total }}</strong>
              </span>
              <div class="scroll">
                @for(training of trainingList?.data; track training.id) {
                <div
                  class="d-flex align-items-center justify-content-between gap-1 my-2 border rounded p-1 bg-body hover-shadow"
                >
                  <div class="d-flex align-items-center">
                    <i class="mdi mdi-text-box-outline fs-2 me-2"></i>
                    <div class="d-flex flex-column">
                      <span
                        class="text-dark font-16 fw-semibold text-break break-word"
                      >
                        {{ training.text }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-1">
                    <div class="dropdown">
                      <i
                        class="mdi mdi-dots-vertical fs-3 cursor-pointer"
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                      </i>
                      <ul class="dropdown-menu">
                        <li>
                          <a class="dropdown-item d-flex align-items-center" (click)="editTextTraining(training)">
                            {{ 'agents.trainingForm.edit' | translate }}
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item d-flex align-items-center" (click)="delete(training.id)">
                            {{ 'agents.trainingForm.delete' | translate }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          } @else{
            @if(!editMode()) {
              <div class="mt-3 alert alert-warning" role="alert">
                {{ 'agents.trainingForm.noTrainings' | translate }}
              </div>
            }
          }
        }
      </div>

      <!-- Website -->
      <div
        class="tab-pane fade"
        id="website"
        role="tabpanel"
        aria-labelledby="website-tab"
      >
        @if(activeTrainingType === TrainingTypeEnum.WEBSITE) {
          <div class="row border rounded p-3">
            <label for="websiteText" class="form-label">{{ 'agents.trainingForm.websiteLabel' | translate }}</label>
            <textarea
              id="websiteText"
              type="text"
              class="form-control"
              formControlName="website"
              placeholder="https://www.seusite.com/pagina-relevante"
              maxlength="1028"
              rows="1"
              (keydown.enter)="$event.preventDefault(); addTrainingWebsite()"
              style="resize: none; overflow-y: auto"
            >
            </textarea>
            <field-error-component
              [field]="'website'"
              [label]="'agents.trainingForm.websiteLabel' | translate"
              [formGroup]="formGroup"
            />
            <div class="d-flex justify-content-end align-items-center mt-3 gap-2 ms-2">
              <div class="col-md-2 col-xs-12">
                <label for="trainingInterval" class="label-form">{{ 'agents.trainingForm.updateInterval' | translate }}</label>
                <mat-select
                  [placeholder]="'agents.trainingForm.updateIntervalPlaceholder' | translate"
                  formControlName="trainingInterval"
                  class="form-control"
                  id="trainingInterval"
                >
                  @for(interval of interval; track interval.value) {
                    <mat-option [value]="interval.value">
                      {{ interval.label | translate }}
                    </mat-option>
                  }
                </mat-select>
              </div>
              <div class="col-md-2 col-xs-12">
                <label for="trainingSubPages" class="label-form">{{ 'agents.trainingForm.navigateSubPages' | translate }}</label>
                <mat-select
                  [placeholder]="'agents.trainingForm.navigateSubPages' | translate"
                  formControlName="trainingSubPages"
                  class="form-control"
                  id="trainingSubPages"
                >
                  <mat-option [value]="'ACTIVE'">{{ 'agents.trainingForm.yes' | translate }}</mat-option>
                  <mat-option [value]="'DISABLED'">{{ 'agents.trainingForm.no' | translate }}</mat-option>
                </mat-select>
              </div>
            </div>
            <div class="mt-3 d-flex align-items-center justify-content-end">
              <button
                type="button"
                class="btn btn-success d-flex align-items-center justify-content-center"
                [disabled]="loading || !formGroup.get('website')?.value?.trim() || formGroup.get('website')?.invalid"
                (click)="addTrainingWebsite()"
              >
                {{ !loadingContent ? ('agents.trainingForm.saveButton' | translate) : "" }}

                @if(loadingContent) {
                <mat-spinner
                  [diameter]="25"
                  [color]="'accent'"
                  mode="indeterminate"
                />
                }
              </button>
            </div>
          </div>
          @if(trainingList?.data?.length > 0) {
            <div class="row p-1 mt-2 ">
              <span>
                {{ 'agents.trainingForm.registeredTrainings' | translate }}
                <strong>{{ trainingList?.total }}</strong>
              </span>
              <div class="scroll">
                @for(training of trainingList?.data; track training.id) {
                <div
                  class="d-flex align-items-center justify-content-between gap-1 my-2 border rounded p-1 bg-body hover-shadow"
                >
                  <div class="d-flex align-items-center">
                    <i class="mdi mdi-link-variant fs-2 me-2" aria-hidden="true"></i>
                    <div class="d-flex flex-column">
                      <span
                        class="text-dark font-16 fw-semibold text-break break-word"
                      >
                        {{ training.website }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <label for="transferToHuman"> </label>
                    <i
                      class="mdi mdi-trash-can-outline fs-3 me-1 cursor-pointer"
                      (click)="delete(training.id)"
                    ></i>
                  </div>
                </div>
                }
              </div>
            </div>
          } @else{
            <div class="mt-3 alert alert-warning" role="alert">
              {{ 'agents.trainingForm.noTrainings' | translate }}
            </div>
          }
        }
      </div>

      <!-- Video -->
      <div
        class="tab-pane fade"
        id="video"
        role="tabpanel"
        aria-labelledby="video-tab"
      >
        @if(activeTrainingType === TrainingTypeEnum.VIDEO) {
            <div class="row border rounded p-3">
              <label for="videoText" class="form-label">{{ 'agents.trainingForm.videoLabel' | translate }}</label>
              <textarea
                id="videoText"
                type="text"
                class="form-control"
                formControlName="video"
                placeholder="https://www.seuvideo.com/exemplo-de-video"
                maxlength="1028"
                rows="1"
                (keydown.enter)="$event.preventDefault(); addTrainingVideo()"
                style="resize: none; overflow-y: auto"
              >
              </textarea>
              <field-error-component
                [field]="'video'"
                [label]="'agents.trainingForm.videoLabel' | translate"
                [formGroup]="formGroup"
              />
              <div class="mt-3 d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  class="btn btn-success d-flex align-items-center justify-content-center"
                  [disabled]="loading || !formGroup.get('video')?.value?.trim() || formGroup.get('video')?.invalid"
                  (click)="addTrainingVideo()"
                >
                  {{ !loadingContent ? ('agents.trainingForm.saveButton' | translate) : "" }}

                  @if(loadingContent) {
                  <mat-spinner
                    [diameter]="25"
                    [color]="'accent'"
                    mode="indeterminate"
                  />
                  }
                </button>
              </div>
            </div>
            @if(trainingList?.data?.length > 0) {
              <div class="row p-1 mt-2 ">
                <span>
                  {{ 'agents.trainingForm.registeredTrainings' | translate }}
                  <strong>{{ trainingList.total }}</strong>
                </span>
                <div class="scroll">
                  @for(training of trainingList?.data; track training.id) {
                  <div
                    class="d-flex align-items-center justify-content-between gap-1 my-2 border rounded p-1 bg-body hover-shadow"
                  >
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-video-outline fs-2 me-2"></i>
                      <div class="d-flex flex-column">
                        <span
                          class="text-dark font-16 fw-semibold text-break break-word"
                        >
                          {{ training.video }}
                        </span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center gap-3">
                      <label for="transferToHuman"> </label>
                      <i
                        class="mdi mdi-trash-can-outline fs-3 me-1 cursor-pointer"
                        (click)="delete(training.id)"
                      ></i>
                    </div>
                  </div>
                  }
                </div>
              </div>
            } @else{
              <div class="mt-3 alert alert-warning" role="alert">
                {{ 'agents.trainingForm.noTrainings' | translate }}
              </div>
            }
        }
      </div>

      <!-- Document -->
      <div
        class="tab-pane fade"
        id="files"
        role="tabpanel"
        aria-labelledby="files-tab"
      >
        @if(activeTrainingType === TrainingTypeEnum.DOCUMENT) {
          <div class="row mt-3 border rounded">
            <div class="rounded-3 p-3">
              <label
                for="dropzone-file"
                class="dz-area w-100"
                role="button"
              >
                <div class="dz-inner text-center">
                  @if (!fileLoaded) {
                    <i
                      class="mdi mdi-cloud-upload-outline mb-2 upload-icon text-muted"
                    ></i>
                    <div class="fw-semibold fs-5 text-dark mb-1">
                      {{ 'agents.trainingForm.uploadPrompt' | translate }}
                    </div>
                    <small class="text-muted">{{ 'agents.trainingForm.uploadHint' | translate }}</small>
                  } @else {
                    <div class="upload-area__image">
                      <i class="mdi mdi-file-document-outline mdi-36px text-primary"></i>
                      <span class="text-primary fw-semibold">{{ filename }}</span>
                      <div>
                        <small class="text-muted">{{ fileSizeMb }}</small>
                      </div>
                    </div>
                    <button
                      class="btn btn-outline-danger mt-2"
                      type="button"
                      (click)="$event.stopPropagation(); clearFileState()"
                    >
                      <i class="mdi mdi-trash-can-outline me-1"></i> {{ 'agents.trainingForm.remove' | translate }}
                    </button>
                  }
                </div>
              </label>

              <input
                id="dropzone-file"
                type="file"
                class="d-none"
                accept=".pdf,.doc,.docx,.txt"
                (change)="handleFileSelect($event)"
                #inputFile
              />
              @if(fileLoaded) {
                <div class="d-flex justify-content-end mt-3">
                  <button
                    class="btn btn-success d-flex align-items-center justify-content-center"
                    type="button"
                    [disabled]="loading || !fileLoaded"
                    (click)="addTrainingDocument()"
                  >
                    {{ 'agents.trainingForm.saveButton' | translate }}
                    @if (loading) {
                      <span class="spinner-border spinner-border-sm ms-1" role="status" aria-hidden="true"></span>
                    }
                  </button>
                </div>
              }
            </div>
          </div>

          @if(trainingList?.data?.length > 0) {
            <div class="row p-1 mt-2 ">
              <span>
                {{ 'agents.trainingForm.registeredTrainings' | translate }}
                <strong>{{ trainingList.total }}</strong>
              </span>
              <div class="scroll">
                @for(training of trainingList?.data; track training.id) {
                <div
                  class="d-flex align-items-center justify-content-between gap-1 my-2 border rounded p-1 bg-body hover-shadow"
                >
                  <div class="d-flex align-items-center">
                    <i class="mdi mdi-cloud-upload-outline fs-2 me-2" aria-hidden="true"></i>
                    <div class="d-flex flex-column">
                      <span
                        class="text-dark font-16 fw-semibold text-break break-word"
                      >
                        {{ training.documentName }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <label for="transferToHuman"> </label>
                    <i
                      class="mdi mdi-trash-can-outline fs-3 me-1 cursor-pointer"
                      (click)="delete(training.id)"
                    ></i>
                  </div>
                </div>
                }
              </div>
            </div>
          } @else{
            <div class="mt-3 alert alert-warning" role="alert">
              {{ 'agents.trainingForm.noTrainings' | translate }}
            </div>
          }
        }
      </div>
    </div>
  </div>
</form>
